import { render } from "./FormModal.vue?vue&type=template&id=01b6bde7&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"

import "./FormModal.vue?vue&type=style&index=0&id=01b6bde7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b6bde7"]])

export default __exports__